import { IUser } from "../../../../../../types/user/iuser.interface";
import { User } from "../../../../../../components/user/user.component";
import { makeKey } from "../../../../../../utils/helpers";
import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";

import { SelectedItems } from "../../../../../common-attributes/components/selected-items/selected-items.component";

import { UserSearchFieldSelectionProps } from "./user-search-field-selection.props";

export const UserSearchFieldSelection = withShowIf((props: UserSearchFieldSelectionProps) => {
  const userMarkers = (user: IUser) => (props.userMarkers && props.userMarkers(user)) ?? [];

  return (
    <SelectedItems>
      {props.users.map((user: IUser, index: number) => (
        <User
          isDisabled={props.isUserReadonly(user)}
          key={makeKey("user", index)}
          markers={userMarkers(user)}
          onRemove={props.onRemove}
          user={user}
        />
      ))}
    </SelectedItems>
  );
});
